import { Link } from "react-router-dom";
import LegalLayout, { LegalSection } from "../components/LegalLayout";
import Seo from "../components/Seo";

export const metadata = { title: "Mentions légales — ML. Agence Web" };

export default function MentionsLegales() {
  return (
    <LegalLayout
      eyebrow="Informations légales"
      title={<>Mentions <span className="text-outline">légales</span></>}
      updated="Juillet 2026"
      intro="Conformément à la loi n°2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), voici les informations relatives à l'éditeur et à l'hébergeur du site ml-agence.fr."
    >
      <Seo title="Mentions légales" description="Mentions légales du site ml-agence.fr — éditeur, hébergement et informations légales de ML. Agence Web." />
      <LegalSection title="Éditeur du site">
        <p>Le site <strong>ml-agence.fr</strong> est édité par <strong>ML. Agence Web</strong>, nom commercial d'une entreprise individuelle immatriculée en France.</p>
        <ul className="space-y-1 text-zinc-400">
          <li>• Forme juridique : entrepreneur individuel (micro-entreprise)</li>
          <li>• SIRET : 994 258 820 00012</li>
          <li>• Code APE : 6201Z — programmation informatique</li>
          <li>• TVA : non applicable, art. 293 B du CGI (franchise en base de TVA)</li>
          <li>• Siège : Île-de-France, France</li>
          <li>• Contact : <a href="mailto:ml.agence04@gmail.com" className="text-[var(--accent)] hover:underline">ml.agence04@gmail.com</a></li>
        </ul>
        <p className="text-sm text-zinc-500">L'adresse postale complète est communiquée sur simple demande à l'adresse e-mail ci-dessus.</p>
        <p>Responsable de la publication : le représentant légal de ML. Agence Web.</p>
      </LegalSection>

      <LegalSection title="Hébergement">
        <p>Le site (interface et fonctions serveur) est hébergé par :</p>
        <p><strong>Vercel Inc.</strong> — 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis — <a href="https://vercel.com" target="_blank" rel="noreferrer" className="text-[var(--accent)] hover:underline">vercel.com</a></p>
        <p>La base de données, l'authentification et le stockage des fichiers de l'espace client sont fournis par :</p>
        <p><strong>Supabase Inc.</strong> — 970 Toa Payoh North #07-04, Singapour / San Francisco, USA — <a href="https://supabase.com" target="_blank" rel="noreferrer" className="text-[var(--accent)] hover:underline">supabase.com</a></p>
        <p>L'envoi des emails transactionnels est assuré par <strong>Resend</strong> (<a href="https://resend.com" target="_blank" rel="noreferrer" className="text-[var(--accent)] hover:underline">resend.com</a>).</p>
      </LegalSection>

      <LegalSection title="Propriété intellectuelle">
        <p>L'ensemble des contenus présents sur ce site (textes, visuels, concepts de réalisation, code, charte graphique) est la propriété exclusive de ML. Agence Web, sauf mention contraire. Les projets présentés dans le portfolio sous le label « Concept ML Agence » sont des exemples de réalisation.</p>
        <p>Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable, est interdite et constitue une contrefaçon au sens des articles L.335-2 et suivants du Code de la propriété intellectuelle.</p>
      </LegalSection>

      <LegalSection title="Données personnelles & cookies">
        <p>Le traitement de vos données personnelles est détaillé dans notre <Link to="/confidentialite" className="text-[var(--accent)] hover:underline">Politique de confidentialité</Link>. L'usage des cookies est décrit dans notre <Link to="/cookies" className="text-[var(--accent)] hover:underline">Politique de gestion des cookies</Link>.</p>
      </LegalSection>

      <LegalSection title="Responsabilité">
        <p>ML. Agence Web s'efforce d'assurer l'exactitude des informations diffusées sur ce site, sans garantir qu'elles soient exemptes d'erreurs. Les liens vers des sites tiers ne sauraient engager la responsabilité de ML. Agence Web quant à leur contenu.</p>
      </LegalSection>

      <LegalSection title="Droit applicable">
        <p>Les présentes mentions légales sont régies par le droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.</p>
      </LegalSection>
    </LegalLayout>
  );
}
